import { InjectionToken } from '@angular/core';

export const ENV_TOKEN = new InjectionToken<Environment>('ANGULAR_STATIC_ENVIRONMENTS');
export const ENV_BUILD_TOKEN = new InjectionToken<Environment>('BUILD_DYNAMIC_ENVIRONMENTS');
